import { SelectOption } from 'global';
import { CreditLineStatuses } from '../../types';

export const creditStatusValues: SelectOption<CreditLineStatuses>[] = [
  { value: CreditLineStatuses.PENDING, label: 'Pending' },
  { value: CreditLineStatuses.APPROVED, label: 'Approved' },
  { value: CreditLineStatuses.DECLINED, label: 'Declined' },
];
